import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-kb-quickorder-err-popup',
    templateUrl: './kb-quickorder-err-popup.component.html',
    styleUrls: ['./kb-quickorder-err-popup.component.scss'],
    standalone: false
})
export class KbQuickorderErrPopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any) { }
}
